document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("#MineQuickBox");
  if (!drawer) return;

  const openBtns = document.querySelectorAll("[data-open-quick-box]");
  const closeBtns = document.querySelectorAll("[data-close-quick-box]");
  const tabs = drawer.querySelectorAll("[data-tab]");
  const groups = drawer.querySelectorAll("[data-group]");
  const totalItems = drawer.querySelector("[data-total-items]");
  const totalPrice = drawer.querySelector("[data-total-price]");
  const addBtn = drawer.querySelector("[data-add-quick-box]");
  const tabsTrack = drawer.querySelector("[data-quick-tabs-track]");
  const prevTabsBtn = drawer.querySelector("[data-quick-tabs-prev]");
  const nextTabsBtn = drawer.querySelector("[data-quick-tabs-next]");
  const content = drawer.querySelector(".mine-quick-box__content");

  const formatMoney = (cents) => {
    return (cents / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  };

  function readProductVariants(product) {
    const el = product.querySelector("[data-variants-json]");
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function productOptionNames(product) {
    const names = [];
    product.querySelectorAll(".mine-quick-product__option").forEach(group => {
      const name = group.getAttribute("data-option-name");
      if (name) names.push(name);
    });
    return names;
  }

  function resolveProductVariant(product) {
    const variants = readProductVariants(product);
    const optionNames = productOptionNames(product);

    const selected = {};
    product.querySelectorAll(".mine-quick-product__variant-option.is-active").forEach(btn => {
      selected[btn.getAttribute("data-option-name")] = btn.getAttribute("data-option-value");
    });

    return variants.find(variant => {
      return variant.available && optionNames.every((name, index) => {
        return !selected[name] || String(variant.options[index]) === String(selected[name]);
      });
    }) || null;
  }

  function updateTotal() {
    let total = 0;
    let totalCents = 0;

    drawer.querySelectorAll(".mine-quick-product").forEach(product => {
      const input = product.querySelector("input");
      const quantity = Number(input.value || 0);
      const price = Number(product.dataset.price || 0);

      total += quantity;
      totalCents += quantity * price;
    });

    totalItems.textContent = total;
    if (totalPrice) totalPrice.textContent = formatMoney(totalCents);
  }

  openBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      drawer.classList.add("active");
      document.body.style.overflow = "hidden";
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      drawer.classList.remove("active");
      document.body.style.overflow = "";
    });
  });

  function setActiveTab(targetTab) {
    tabs.forEach(t => {
      t.classList.toggle("active", t.dataset.tab === targetTab);
    });
  }

  function scrollToGroup(targetTab) {
    const group = drawer.querySelector(`[data-group="${targetTab}"]`);
    if (!group || !content) return;

    content.scrollTo({
      top: group.offsetTop - content.offsetTop,
      behavior: "smooth"
    });
  }

  function updateActiveTabByScroll() {
    if (!content || !groups.length) return;

    const current = Array.from(groups).findLast((group) => {
      return group.offsetTop - content.scrollTop <= 24;
    }) || groups[0];

    if (current) {
      setActiveTab(current.dataset.group);
    }
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const targetTab = tab.dataset.tab;
      setActiveTab(targetTab);
      tab.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      scrollToGroup(targetTab);
    });
  });

  function scrollTabs(direction) {
    if (!tabsTrack) return;
    tabsTrack.scrollBy({
      left: direction * 180,
      behavior: "smooth"
    });
  }

  if (prevTabsBtn) {
    prevTabsBtn.addEventListener("click", () => scrollTabs(-1));
  }

  if (nextTabsBtn) {
    nextTabsBtn.addEventListener("click", () => scrollTabs(1));
  }

  if (content) {
    content.addEventListener("scroll", updateActiveTabByScroll);
  }

  drawer.addEventListener("click", e => {
    const product = e.target.closest(".mine-quick-product");
    if (!product) return;

    const input = product.querySelector("input");

    if (e.target.matches("[data-plus]")) {
      input.value = Number(input.value) + 1;
    }

    if (e.target.matches("[data-minus]")) {
      input.value = Math.max(0, Number(input.value) - 1);
    }

    const optionBtn = e.target.closest(".mine-quick-product__variant-option");
    if (optionBtn) {
      const optionGroup = optionBtn.closest(".mine-quick-product__option");
      if (optionGroup) {
        optionGroup.querySelectorAll(".mine-quick-product__variant-option").forEach(function(btn) {
          btn.classList.toggle("is-active", btn === optionBtn);
        });
      }

      const variant = resolveProductVariant(product);
      if (variant) {
        const newVariantId = variant.id;
        const newPrice = Number(variant.price || 0);
        product.dataset.variantId = newVariantId;
        product.dataset.price = newPrice;
        const priceLabel = product.querySelector("[data-product-price]");
        if (priceLabel) priceLabel.textContent = formatMoney(newPrice);
        input.value = 0;
      }
    }

    updateTotal();
  });

  addBtn.addEventListener("click", async () => {
    const items = [];

    drawer.querySelectorAll(".mine-quick-product").forEach(product => {
      const quantity = Number(product.querySelector("input").value);

      if (quantity > 0) {
        items.push({
          id: Number(product.dataset.variantId),
          quantity
        });
      }
    });

    if (!items.length) {
      alert("Escolha pelo menos um produto.");
      return;
    }

    addBtn.disabled = true;
    addBtn.textContent = "Adicionando...";

    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items })
      });

      window.location.href = "/cart";
    } catch (error) {
      alert("Não foi possível adicionar ao carrinho.");
      addBtn.disabled = false;
      addBtn.textContent = "Adicionar ao carrinho";
    }
  });

  updateTotal();
  updateActiveTabByScroll();
});
